import filterSchedule from './scheduleFilter';
import filterAsync from '../helpers/filterAsync';

const defaultFilterAll = {
  id: 'default_all',
  scope: 'imkino',
  label: 'Alle Filme',
  value: null,
  filter: null,
  sortOrder: 0,
  isDealFilter: false,
  isTopFilter: false,
  isVodFilter: false,
};

const defaultFilterTop = {
  id: 'default_top10',
  scope: 'imkino',
  label: 'Top 10',
  value: null,
  filter: null,
  sortOrder: 1,
  isDealFilter: false,
  isTopFilter: true,
  isVodFilter: false,
};

const defaultFilterDeals = {
  id: 'default_deals',
  scope: 'imkino',
  label: 'Deals',
  value: null,
  filter: null,
  sortOrder: 0,
  isDealFilter: true,
  isTopFilter: false,
  isVodFilter: false,
};

const defaultFilterVods = {
  id: 'default_vods',
  scope: 'imkino',
  label: 'Cineplex Home',
  value: null,
  filter: null,
  sortOrder: 0,
  isDealFilter: false,
  isTopFilter: false,
  isVodFilter: true,
};

export default async ({ films, filters, settings }, scope = 'imkino') => {
  // remove all filters w/o scope 'imkino'
  const validScopeFilters = filters.filter(
    (filter) => filter.scope === scope
  );

  const allFilters = [
    defaultFilterAll,
    defaultFilterTop,
    defaultFilterDeals,
    ...validScopeFilters,
  ];

  // remove filters w/o results
  const filtersWithResults = await filterAsync(allFilters, async (filter) => {
    if (filter.isVodFilter) {
      return true; // vods should always be present
    }

    const filteredFilms = await filterSchedule(films, filter);
    console.log(`Filter "${filter.label}" has ${filteredFilms.length} results`);

    return filteredFilms.length > 0;
  });

  // activate first of the remaining filters
  const activeFilter = filtersWithResults.find((_, index) => index === 0);

  return { films, filters: filtersWithResults, activeFilter, settings };
};
